import { render, staticRenderFns } from "./repair-cultural.vue?vue&type=template&id=ef67131c&scoped=true"
import script from "./repair-cultural.vue?vue&type=script&lang=js"
export * from "./repair-cultural.vue?vue&type=script&lang=js"
import style0 from "./repair-cultural.vue?vue&type=style&index=0&id=ef67131c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef67131c",
  null
  
)

export default component.exports